export const SharedParams = {
    Email: 'email',
    Dropdown: 'dropdown',
    Trainees: 'trainees',
    Status: 'status',
    Exporting: 'exporting',
    Importing: 'importing',
    Uploading: 'uploading',
    Dashboard: 'dashboard',
    HomeStatus: 'home-status',
};
